<script>
function generarColorAleatorio() {
  // Generar colores pasteles aleatorios
  // Los colores pasteles tienen valores RGB altos (entre 180-255) para mantener la suavidad

  const r = Math.floor(Math.random() * 76) + 180; // 180-255
  const g = Math.floor(Math.random() * 76) + 180; // 180-255
  const b = Math.floor(Math.random() * 76) + 180; // 180-255

  // Convertir a hexadecimal
  const color =
    "#" +
    r.toString(16).padStart(2, "0") +
    g.toString(16).padStart(2, "0") +
    b.toString(16).padStart(2, "0");

  return color;
}

export default {
  data() {
    return {
      focus: false,
      title: "",
    };
  },
  methods: {
    createColumn() {
      const title = this.title.trim();
      if (!title) return;

      const column = {
        title,
        color: generarColorAleatorio(),
      };

      this.$emit("createColumn", column);

      this.title = "";
    },
  },
};
</script>

<template>
  <div class="creator-columns" :class="{ focus: focus }">
    <textarea
      v-model="title"
      @focus="focus = true"
      @blur="focus = false"
      @keyup.enter="createColumn"
      :class="{ focus: focus }"
      class="column-title"
      type="text"
      :placeholder="focus ? 'Titulo de la columna' : 'Nueva columna'"
    ></textarea>
    <transition name="fade">
      <div v-show="focus" class="controls">
        <vs-button @click="createColumn">Crear</vs-button>
        <vs-button
          danger
          @clcik="
            title = '';
            focus = false;
          "
        >
          Cancelar
        </vs-button>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.creator-columns {
  display: inline-block;
  max-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: 0.5s ease-in-out;
  position: relative;
  min-width: 250px;
  border-radius: 8px;
  cursor: move;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  background-color: var(--lego-dbg);
  border: 1px solid #e1e5e9;

  .dark & {
    /* background-color: var(--lego-oscuro); */
    border-color: var(--lego-hoscuro);
  }

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    .dark & {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    }
  }
}
.creator-columns.focus {
  max-height: 150px;
  padding: 0.5rem;
}
.controls {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.column-title {
  background-color: transparent;
  letter-spacing: 0.25rem;
  border: 0;
  outline: none;
  font-weight: normal;
  cursor: pointer;
  transition: 0.5s ease-in-out;
  color: var(--lego-gris);
  border-radius: 3px;
  resize: none;
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 1rem;
  margin: 0;

  .dark & {
    color: white;
  }
}

.column-title.focus {
  background-color: var(--lego-light-hover);
  .dark & {
    background-color: var(--lego-bg);
  }
  cursor: text;
  margin-bottom: 0.5rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
